/*
 * Application error handling.
 */
import CoreComponent from './CoreComponent';

export default class ErrorBoundary extends CoreComponent {
    constructor(props) {
        super(props);
        this.state = {
            error: false,
        };
    }

    componentDidCatch(error, errorInfo) {
        this.setStatePrev({ error, errorInfo }).then(() => {
            this.props.onError?.(error, errorInfo);
            try {
                window.ErrorReporter[this.props.mode || 'error'](error, errorInfo);
            } catch {
                console.trace(error, errorInfo);
            }
        });
    }

    render() {
        let { error, errorInfo } = this.state,
            { children, fallback } = this.props;

        if (error) {
            if (fallback) return fallback(error, errorInfo);

            return (
                <div style={{ padding: '10px' }}>
                    <h2>Sorry, something went wrong.</h2>
                    <details style={{ whiteSpace: 'pre-wrap', display: 'block' }}>
                        {error?.toString?.()}
                        <br />
                        {errorInfo?.componentStack||'No stack!'}
                    </details>
                </div>
            );
        }

        return children;
    }
}
